export default (contentType: string, label?: string): string => {
    return `anchor_${contentType}_${label}}`;
};